import React, { useEffect, useState } from 'react';
import { requestApi } from 'utils/request';
import StyledActiveButton from 'components/Button/StyledActiveButton';
import GoBackToPrev from '../../GoBackToPrev';
import ROUTE_PATH from 'routes/config';
import CommonModal from 'components/Modal/CommonModal';
import { MainWrapper } from '../style';
import { Label } from '../../../MyPage/MyInform/MemberWithdrawal/MemberWithdrawalPage/style';
import {
  IconSpan,
  RadioInput,
} from 'components/SelectManager/SelectManagerRow/style';
import { DEFAULT_MANAGER_DATA_LIST } from './constants';
import { COMMON_ERR_MESSAGE } from '../../../../constants/message';
import { useApp } from '../../../../contexts/AppContext';
import { useLocation } from 'react-router-dom';

const SelectManagerStep = ({
  mode,
  accountType,
  formData,
  setFormData,
  selectedMallData,
  selectedManager,
  setSelectedManager,
  dataProviderSeq,
  setHasOtherMallAccount,
  setStep,
  businessDataProviderMallMappingSeq,
  stipulationListForMall = [],
  setCaptchaData,
}) => {
  const location = useLocation();
  const { auth } = useApp();
  const { memberRoleData, memberTotalData } = auth;
  const [managerList, setManagerList] = useState(DEFAULT_MANAGER_DATA_LIST);
  // api 통신 진행중: 추가적인 작업 불가능 (버튼 더블 클릭 등)
  const [isFetching, setIsFetching] = useState(false);
  // 모달
  const [modalData, setModalData] = useState({});
  const [showModal, setShowModal] = useState(false);

  // 데이터 연동 정보 수정 > 2차인증 정보 변경 > '직접 인증' 선택으로 진입한 케이스
  const isDirectContactStep = location?.state?.step === 'contactStep';

  // 데이터 연동 관리 > QR 에러 발생(FRT125) 으로 진입한 케이스
  const isDirectQRStep = location?.state?.step === 'QRStep';
  // 사업자 대표 여부
  const isRepresentation = memberRoleData?.representativeYn === 'Y';
  const {
    mallId,
    mallPassword,
    secondAuthReleaseYn,
    secondAuthValue,
    secondAuthType,
    extraAuthFactor,
    qrFileSeq,
    qrFileUrl,
  } = formData;

  const {
    mallSeq,
    mallScrapingTypeCd,
    secondAuthUseYn,
    secondAuthExposureType,
    secondAuthCategoryCd,
  } = selectedMallData;

  const {
    interlockBusinessManagerName,
    interlockBusinessManagerMobilePhoneNumber,
  } = selectedManager;

  const isDisabledBtn = () => {
    return (
      !interlockBusinessManagerName ||
      !interlockBusinessManagerMobilePhoneNumber ||
      isFetching
    );
  };

  // 이전으로 돌아가기 버튼 클릭
  const onClickBackBtn = () => {
    setSelectedManager({
      interlockBusinessManagerName: '',
      interlockBusinessManagerMobilePhoneNumber: '',
    });
    setCaptchaData({});

    // 2차인증 사용
    if (secondAuthUseYn === 'Y') {
      // 2차인증 수단: 문자/이메일
      if (secondAuthCategoryCd === 'SAM100') {
        if (
          secondAuthExposureType === 'INTERLOCK_ADD_AND_MODIFY' ||
          (secondAuthExposureType === 'INTERLOCK_MODIFY' && mode === 'modify')
        ) {
          setStep('contactStep');
        } else {
          setStep('accountStep');
        }
      } else {
        // 2차인증 수단: QR (SAM200)
        if (secondAuthType === 'SAT132') {
          // QR 발생
          setStep('QRStep');
        } else {
          setStep('accountStep');
        }
      }
    } else {
      // 2차인증 미사용
      setStep('accountStep');
    }
  };

  const onClickDataLinkageBtn = () => {
    setIsFetching(true);
    const formatStipulationList = stipulationList =>
      stipulationList?.map(item => ({
        dataProviderMallStipulationMappingSeq:
          item?.dataProviderMallStipulationMappingSeq,
        stipulationSubject: item?.stipulationCdName,
        stipulationContents: item?.stipulationContents,
        agreeYn: item?.checked ? 'Y' : 'N',
      }));

    // 등록, 수정 공통 데이터
    const commonData = {
      dataProviderSeq,
      mallScrapingTypeCd,
      mallAccountTypeCd: accountType === 'main' ? 'M' : 'S',
      mainMallId: accountType === 'main' ? mallId : '',
      mainMallPassword: accountType === 'main' ? mallPassword : '',
      subMallId: accountType === 'sub' ? mallId : '',
      subMallPassword: accountType === 'sub' ? mallPassword : '',
      businessManagerName: interlockBusinessManagerName,
      businessManagerMobilePhone:
        interlockBusinessManagerMobilePhoneNumber?.replaceAll('-', ''),
      extraAuthFactor: extraAuthFactor,
      secondAuthReleaseYn: secondAuthReleaseYn === 'Y' ? 'Y' : 'N',
      secondAuthUseYn,
      secondAuthValue,
      secondAuthType,
      qrFileSeq,
    };

    const postData = {
      ...commonData,
      mallSeq,
      businessDataProviderMallMappingSeq,
      agreeStipulationList: formatStipulationList(stipulationListForMall),
    };

    const putData = {
      ...commonData,
    };

    if (mode === 'register') {
      // 데이터 연동 등록 api
      (async () => {
        await fetchInterlockMall({
          url: '/v1/au/data-provider-mall/interlock',
          method: 'POST',
          data: postData,
        });
      })();
    } else {
      // 데이터 연동 수정 api
      (async () => {
        await fetchInterlockMall({
          url: `/v1/au/data-provider-mall/interlock/${businessDataProviderMallMappingSeq}`,
          method: 'PUT',
          data: putData,
        });
      })();
    }
  };

  const onClickBlueLink = () => {
    window.open(ROUTE_PATH.mypage.manager, '_blank');
  };

  const onChangeRadioBtn = event => {
    const selectedManager = managerList?.find(
      item => Number(event.target.value) === item.businessManagerSeq
    );
    setSelectedManager({
      interlockBusinessManagerName: selectedManager.managerName,
      interlockBusinessManagerMobilePhoneNumber: selectedManager.mobilePhone,
    });
  };

  // 판매몰 연동 등록/수정 api
  const fetchInterlockMall = async ({ url, method, data }) => {
    try {
      const res = await requestApi({
        url,
        method,
        data,
      });

      if (res.success) {
        setStep('completionStep');
        setHasOtherMallAccount(res.data.possibleInterlockYn);
      } else {
        setShowModal(true);
        setModalData({
          contents: res.data.message,
        });
      }
    } catch (error) {
      if (error.response.data.errorCode === 500) {
        setShowModal(true);
        setModalData({
          contents: error.response.data.message,
        });
      } else {
        setShowModal(true);
        setModalData({
          contents: COMMON_ERR_MESSAGE,
        });
      }
    } finally {
      setIsFetching(false);
    }
  };

  // 담당자 리스트 조회 api
  const fetchManagerList = async () => {
    try {
      const res = await requestApi({
        url: '/v1/au/manager',
        method: 'GET',
      });
      if (res.success) {
        const validDataList = res.data.list?.filter(
          item =>
            item?.useYn === 'Y' &&
            (item?.representationYn === 'Y' ||
              item?.invitationCompletionYn === 'Y')
        );
        setManagerList(validDataList);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    // 직원일 경우, 접속한 해당 직원 정보로 설정
    if (!isRepresentation) {
      setSelectedManager({
        interlockBusinessManagerName: memberTotalData.memberName,
        interlockBusinessManagerMobilePhoneNumber: memberTotalData.mobilePhone,
      });
    }
  }, [isRepresentation]);

  useEffect(() => {
    (async () => {
      await fetchManagerList();
    })();
  }, []);

  return (
    <MainWrapper>
      {!(isDirectContactStep || isDirectQRStep) && (
        <GoBackToPrev onClickReset={onClickBackBtn} />
      )}
      <div className="contentsWrapper">
        <p className="title">
          마지막으로 직원 선택 후<br /> 데이터 연동 요청을 진행해 주세요
          <br />
          <span>연동 결과를 안내 받을 직원을 선택해 주세요</span>
        </p>
        <div className="selectManagerStepBox">
          <section>
            {managerList?.length > 0 &&
              !!managerList[0].businessManagerSeq &&
              managerList.map((manager, index) => {
                const {
                  businessManagerSeq,
                  managerName,
                  mobilePhone,
                  department,
                  position,
                } = manager;
                return (
                  <div key={index} className="infoRow">
                    <div>
                      <Label className="check-card">
                        <RadioInput
                          type="radio"
                          className="check-card"
                          value={businessManagerSeq}
                          checked={
                            mobilePhone?.replaceAll('-', '') ===
                            interlockBusinessManagerMobilePhoneNumber?.replaceAll(
                              '-',
                              ''
                            )
                          }
                          onChange={onChangeRadioBtn}
                        />
                        {managerName}
                        <IconSpan className="notice-check-icon" />
                      </Label>
                      <span>{!!mobilePhone && mobilePhone}</span>
                    </div>
                    {department && (
                      <p>
                        {department}
                        {department && position && '/'}
                        {position}
                      </p>
                    )}
                  </div>
                );
              })}
          </section>
          <p className="bottomNotice">
            선택한 담당자의 휴대폰 번호가 정확한지 확인해 주세요.
            <br />
            연동 실패나 2차 인증 필요 시 안내 문자가 발송됩니다.
            <br />
            휴대폰 번호 수정 또는 신규 담당자 추가가 필요하다면?
          </p>
          <a
            onClick={onClickBlueLink}
            target="_blank"
            tabIndex={0}
            title="직원관리 페이지로 이동"
          >
            담당자 등록(수정)하기
          </a>
          <div className="nextBtnBox">
            <StyledActiveButton
              onClick={onClickDataLinkageBtn}
              disabled={isDisabledBtn()}
            >
              데이터 연동 요청
            </StyledActiveButton>
          </div>
        </div>
      </div>
      <CommonModal
        modalData={modalData}
        setShowModal={setShowModal}
        showModal={showModal}
      />
    </MainWrapper>
  );
};

export default SelectManagerStep;
